<template>
	<div class="F">
		<router-view></router-view>
		<Footer/>
	</div>


</template>

<script>
	import Header from "./../components/Header";
	import Footer from "./../components/footer";
	export default {
		name: 'subject',
		components: {
			Header,
			Footer
		},
        mounted(){
            //alert(1)
        },
	}
</script>
<style>
</style>
